import { logErrorNR } from '@barracuda/shared/utils/log-error-nr';
import { getThumbmarkDeviceId } from '@/utils/thumbmark';
import { ANONYMOUS_FEATURE_FLAGS_FALLBACK_KEY } from '@barracuda/shared';

export const DEFAULT_ENV = 'dev';
export const LOCALHOST_AUTHORIZATION_KEY = 'localhost';
export const DEFAULT_READY_TIMEOUT_SECONDS = 5;

export enum FeatureFlagsMode {
  REMOTE = 'remote',
  LOCAL = 'local',
  FALLBACK = 'fallback'
}

export const FEATURE_FLAGS_MODE_MESSAGES: Record<FeatureFlagsMode, string> = {
  [FeatureFlagsMode.REMOTE]: 'Feature flags in REMOTE mode: connected to Harness FME.',
  [FeatureFlagsMode.LOCAL]:
    'Feature flags in LOCAL mode (REACT_APP_LOCAL): no Harness key, serving localhost treatments.',
  [FeatureFlagsMode.FALLBACK]:
    'Feature flags in FALLBACK mode: HARNESS_FME_CLIENT_SDK_KEY is missing outside local dev; serving localhost treatments. Configure the key for this environment.'
};

interface ResolveFeatureFlagsIdentityKeyParams {
  isLoggedIn: boolean;
  anonymousId: string;
  externalId?: string;
}

export const resolveFeatureFlagsIdentityKey = ({
  isLoggedIn,
  anonymousId,
  externalId
}: ResolveFeatureFlagsIdentityKeyParams): string =>
  isLoggedIn && externalId ? externalId : anonymousId;

export const resolveFeatureFlagsMode = (
  sdkKey?: string,
  isLocalEnvironment = false
): FeatureFlagsMode => {
  if (sdkKey) {
    return FeatureFlagsMode.REMOTE;
  }

  return isLocalEnvironment ? FeatureFlagsMode.LOCAL : FeatureFlagsMode.FALLBACK;
};

export const getAnonymousId = async (): Promise<string> => {
  try {
    return await getThumbmarkDeviceId();
  } catch (error: unknown) {
    logErrorNR(
      error,
      '[HarnessFeatureFlagsProvider] Failed to resolve Thumbmark device id; using fallback',
      'warn',
      console
    );
    return ANONYMOUS_FEATURE_FLAGS_FALLBACK_KEY;
  }
};
